import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";

export const deleteAssistant = async (assistantId: string) => {
  const fn = httpsCallable(functions, "deleteAssistant");
  try {
    const { data: responseData } = await fn({ assistantId });
    return responseData;
  } catch (error) {
    return {
      errorMessage: (error as Error).message.split(":")[0],
    };
  }
};
